import { useEffect } from "react";
import { useSelector } from "react-redux";
import TwoColumnLayOut from "../../layouts/two-columns/two-column-layout";
import { RootState, useAppDispatch } from "../../redux/store";
import { useParams, useLocation, Location } from "react-router-dom";
import { retrieveProductDetails } from "../../redux/slice/products/product-details-slice";
import { retrieveTaxonomyProduct } from "../../redux/slice/taxonomy-product-slice";
import { retrieveProductRightSideBooks } from "../../redux/slice/right-side/product-right-side-books-slice";
import { retrieveProductRightSideLearning } from "../../redux/slice/right-side/product-right-side-learning-slice";
import { retrieveProductRightSideNews } from "../../redux/slice/right-side/product-right-side-news-slice";
import { retrieveProductRightSideRelatedEvents } from "../../redux/slice/right-side/product-right-side-related-events-slice";
import { Helmet } from "react-helmet-async";
import LoadingComp from "../../components/re-usable/loading/loading";

const ProductDetails = () => {
  const routeParams = useParams();
  const dispatch = useAppDispatch();
  const location: Location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isSale = queryParams.has("sale");

  const { ProductDetailsData } = useSelector((state: RootState) => state.ProductDetails);
  const { rightSideFeaturedBooksData } = useSelector((state: RootState) => state.ProductRightSideBook);
  const { rightSideFeaturedLearningData } = useSelector((state: RootState) => state.ProductRightSideLearning);
  const { rightSideTrendingNewsData } = useSelector((state: RootState) => state.ProductRightSideNews);
  const { rightSidePopularEventsData } = useSelector((state: RootState) => state.ProductRightSideRelatedEvents);
  const { data } = useSelector((state: RootState) => state.taxonomyProduct);
  let productDetails = ProductDetailsData[0]?.productInfoItemsList;
  const path = routeParams.path;

  let detailPageNewsTrail = {
    trendingNewsData: rightSideTrendingNewsData,
    popularEventsData: rightSidePopularEventsData,
    featuredLearningData: rightSideFeaturedLearningData,
    featuredBooksData: rightSideFeaturedBooksData,
  };

  useEffect(() => {
    if (path) {
      dispatch(retrieveProductDetails(path));
      dispatch(retrieveTaxonomyProduct(path));
      dispatch(retrieveProductRightSideBooks(path));
      dispatch(retrieveProductRightSideLearning(path));
      dispatch(retrieveProductRightSideNews(path));
      dispatch(retrieveProductRightSideRelatedEvents(path));
    }
  }, [path, dispatch]);

  useEffect(() => {
    if (productDetails) {
      document.title = productDetails[0]?.name;
    }
  }, [productDetails]);

  if (productDetails === undefined || productDetails === null) return <LoadingComp />;

  const formatPrice = (price: string) => {
    let formattedPrice = price.replace("$", "");
    let parseFloatCheck = parseFloat(formattedPrice);
    let parseIntCheck = parseInt(formattedPrice);

    if ((parseFloatCheck || parseFloatCheck === 0) || (parseIntCheck || parseIntCheck === 0)) {
      return `<span itemprop='priceCurrency' content='USD'>$</span><meta itemprop='price' content='${formattedPrice.replace(/[,]/g, "")}'><span>${formattedPrice}</span>`
    }

    return price;
  }

  const formatPricing = (pricing: string) => {
    let prices = pricing.split(/\r?\n|\r|\n/g)[0].split(' ');

    prices.map((item, index) => {
      let removedCurr = item.replace("$", "");
      let parseFloatCheck = parseFloat(removedCurr);
      let parseIntCheck = parseInt(removedCurr);

      if ((parseFloatCheck || parseFloatCheck === 0) || (parseIntCheck || parseIntCheck === 0)) {
        prices[index] = "<span itemscope itemprop='offers' itemtype='https://schema.org/Offer'>" + formatPrice(item) + "</span>"
      }
      return prices.join(" ")
    });

    return prices.join(" ");
  };

  const getDescription = (fullDesc: string) => {
    var shortDescription = fullDesc;

    var descParts = fullDesc.split(/\r?\n|\r|\n/g)
    if (descParts.length > 1) shortDescription = descParts.slice(1).join(" ");

    return shortDescription;
  };

  return (
    <>
      <Helmet>
        <title>{ProductDetailsData[0]?.productInfoItemsList[0]?.isPublic ? ProductDetailsData[0]?.productInfoItemsList[0]?.menuItemName : `| RAPS`}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={`${path}`} isBreadcrumbpath={false} detailPageTaxonomy={data} detailPageNewsTrail={detailPageNewsTrail} showAds={true} isDetails={true} addSchema={true} schemaOptions={{ itemType: "https://schema.org/Product" }}>
        {productDetails?.length < 1 && "Product is not found"}
        {productDetails &&
          productDetails.map((item, index) => {
            var pricing = formatPricing(item.shortDescription) || item.shortDescription;
            if (isSale && item.alternatePricing !== "") pricing = formatPricing(item.alternatePricing) || item.alternatePricing;

            return item.isPublic ? (
              <div className="ed-content" id="edcontent" key={index}>
                <div className="row">
                  <div className="col-lg-8 col-md-12">
                    <div className="category-type" style={{ display: "block" }}><span dangerouslySetInnerHTML={{ __html: item.badge }}></span></div>
                    <h1 id="title" itemProp="name" style={{ marginTop: "5px" }} className="pd-header h1">{item.name}</h1>
                    <input type="hidden" id="hdnProductCode" value={item.code} />

                    {item.educationCredits > 0.0 ? (
                      <span className="products" style={{ marginRight: "20px", display: "inline" }}>
                        <span className="meta-item rac-credits">
                          <span style={{ margin: "3px 0" }} className="rac-credits">
                            <span style={{ marginRight: "6px" }} className="badge badge-credits">{" "}{item.educationCredits}{" "}</span>
                            <span className="badge-label">RAC Credits</span>{" "}
                          </span>
                        </span>
                      </span>
                    ) : null}

                    <span className="pricing" dangerouslySetInnerHTML={{ __html: pricing }}></span>
                    <div className="cta product-details-cta" style={{ marginTop: "12px" }}>
                      <span dangerouslySetInnerHTML={{ __html: item.addtoCartBtn }}></span>
                      {item.hasEbook ? <span dangerouslySetInnerHTML={{ __html: item.addEbookToCartBtn }}></span> : null}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <span style={{ display: "block" }}>
                      <img itemProp="image" alt={item.name} src={item.imageUrl} style={{ maxHeight: "250px", marginLeft: "6px" }} />
                    </span>
                  </div>
                </div>
                <div dangerouslySetInnerHTML={{ __html: item.longDescription }}></div>

                <div className="cta product-details-cta" style={{ marginTop: "20px" }}>
                  <span dangerouslySetInnerHTML={{ __html: item.addtoCartBtn }}></span>
                  {item.hasEbook ? <span dangerouslySetInnerHTML={{ __html: item.addEbookToCartBtn }}></span> : null}
                </div>
                <span itemScope={true} itemType="https://schema.org/Brand" itemProp="brand">
                  <span itemProp="name" {...{ content: "Regulatory Affairs Professionals Society" }}></span>
                </span>
                <span itemScope={true} itemProp="description" {...{ content: getDescription(item.shortDescription) }}></span>
              </div>
            ) : (
              "Product is not valid "
            );
          })}
      </TwoColumnLayOut>
    </>
  );
};

export default ProductDetails;
